
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.174","height":"22.237"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_1-2","transform":"translate(-2)"}},[_c('g',{attrs:{"id":"Group_34053","data-name":"Group 34053"}},[_c('g',{attrs:{"id":"logoMark","transform":"translate(2)"}},[_c('path',{attrs:{"id":"Path_24024","data-name":"Path 24024","d":"M10.034 170.56l-2.267.1v3.889H3.578L3.5 169.4l-.123-.169H3.37a6.14 6.14 0 002.77 11.619h.525a6.14 6.14 0 006.139-6.14v-4.478c-.067-.008-.163-.346-.23-.349-.831-.029-1.649.678-2.54.677z","transform":"translate(0 -158.612)","fill":"#1ccdfd"}}),_c('path',{attrs:{"id":"Path_24025","data-name":"Path 24025","d":"M65.862 3.369A6.139 6.139 0 0060.384 0h-.525a6.139 6.139 0 00-6.139 6.14v4.478l.092.355a6.047 6.047 0 012.675-.91h2.052l-.008-3.917 4.508-.024-.017 5.271.132.226a6.14 6.14 0 002.708-8.25z","transform":"translate(-50.35)","fill":"#c458fb"}}),_c('path',{attrs:{"id":"logoMark_PathItem_3","d":"M58.469 96.66v3.894H56.49a6.113 6.113 0 00-2.77.659v5.555h4.68v-3.894h1.979a6.113 6.113 0 002.77-.659V96.66z","transform":"translate(-50.35 -90.595)","fill":"#854cf9"}})])])])])
          )
        }
      }
    